import { Component, OnInit } from '@angular/core';
import {Banner} from '../../models/banner.model';
import {BannersService} from '../../services/banners.service';
import {Router} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';
import {ConfigKeys} from '../../config/config.keys';
import {CampaignsService} from '../../services/campaigns.service';
import {Campaign} from '../../models/campaign.model';
import {GoogleAnalyticsService} from 'mugan86-ng-google-analytics';

@Component({
  selector: 'app-banners-hp',
  templateUrl: './banners-hp.component.html',
  styleUrls: ['./banners-hp.component.css']
})
export class BannersHpComponent implements OnInit {

  banners: Banner[] = [];
  idCardSelected: number = 1;
  configKeys: ConfigKeys = new ConfigKeys();
  campaign: Campaign;

  constructor(
    private bannersService: BannersService,
    private campaignsService: CampaignsService,

    private googleAnalyticsService: GoogleAnalyticsService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.bannersService.getBannersHomePage()
      .subscribe(
        (banners: Banner[]) => {
          this.banners = banners;
          this.bannersService.setBannersHomePage(banners);
        }
      );
  }

  getMobileFormat(bannerName : string){

    return bannerName.replace('promo-name', 'promo-name-mobile');

  }

  showCampaign(idCamp: number, urlExterna: string, bannerName: string, brandName: string){

    //console.log('Clicked showCampaign... ')

    //console.log('idCamp: ' + idCamp);
    //console.log('urlExterna: ' + urlExterna);

    // if(idCamp!==-1){
    //   this.router.navigate(['showCampaign',idCamp],{skipLocationChange: true, replaceUrl: false});
    // }

    if(bannerName!==null && bannerName.length>0)
     bannerName = bannerName.replace(/<\/?[^>]+(>|$)/g, "");

    //--------------Call Google Analytics Event
    var tipoPromoNombre = 'Banners';
    var tipoPromo = 'Banner ';
    var cardType = 'Home Page'
    this.googleAnalyticsService.eventEmitter(tipoPromoNombre, cardType, tipoPromo + '(' + cardType + '): ' + brandName  + ' - '  + bannerName, 1);
    //--------------Call Google Analytics 4 Event
    this.eventGA4PushInteractions('bancoppel_banners', cardType, tipoPromo + '(' + cardType + '): ' + brandName  + ' - '  + bannerName);


    if (idCamp === -1 && urlExterna !== undefined && urlExterna.trim().length>0) {
      window.open(urlExterna, '_blank');
    } else
    if (idCamp !== -1)
     {
      this.campaignsService.getCampaign('' + idCamp).subscribe((campaign: Campaign) => {
        this.campaign = campaign;
        this.campaignsService.setCampaign(campaign);
        let url = this.configKeys.URL_APP_MAIN + 'showCampaign/' + idCamp + '/1?' + this.campaign.utmParametros;
        window.open(url, '_self');

      });
    }

  }


  eventGA4PushInteractions(event: string, card_campaign_sendingmean: string, labelValue: string) {

    // console.log('Registering event in GA4: ' + event);

    if (event === 'bancoppel_promociones') {
      (<any>window).dataLayer.push({
        event: event,
        card_campaign: card_campaign_sendingmean,
        promo_name: labelValue
      });
    } else if (event === 'bancoppel_banners') {
      (<any>window).dataLayer.push({
        event: event,
        card_campaign_banners: card_campaign_sendingmean,
        banner_name: labelValue
      });
    } else if (event === 'social_share') {
      (<any>window).dataLayer.push({
        event: event,
        sending_mean: card_campaign_sendingmean,
        promo_name_ss: labelValue
      });
    }
  }


  getInnerHTML(html: string){

    const regex = /<[^>]+>/g;
    const noTagsText = html.replace(regex, '');

    return noTagsText;
  }

}
